import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl'

import PasswordInput from 'components/PasswordInput'
import Button from 'components/Button'
import validatorPassword from 'validators/password'
import { showErrorToast, showSuccessToast } from 'utils/toast'
import { requestChangePasswordForAuthorizedUser } from 'api/user'
import { FORGOT_PASSWORD_PATH } from 'routing/constants'

const ChangePasswordModalForm = ({ toggleModal }) => {
  const [currentPassword, setOldPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmNewPassword, setConfirmNewPassword] = useState('')
  const [error, setError] = useState({ field: '', error: '' })
  const [isFormSubmitted, setIsFormSubmitted] = useState(false)

  const handleOldPasswordChange = (e) => {
    setOldPassword(e.target.value)
  }

  const handleNewPasswordChange = (e) => {
    setNewPassword(e.target.value)
  }

  const handleConfirmNewPasswordChange = (e) => {
    setConfirmNewPassword(e.target.value)
  }

  const isFormValid = () => {

    if (!currentPassword.length) {
      setError({ field: 'currentPassword', error: 'enterOldPassword' })
      return false
    }

    if (!newPassword.length && !confirmNewPassword.length) {
      setError({ field: 'newPassword', error: 'enterAndConfirmNewPassword' })
      return false
    }

    if (!confirmNewPassword.length) {
      setError({ field: 'confirmNewPassword', error: 'confirmPasswordEmpty' })
      return false
    }

    if (!validatorPassword(newPassword)) {
      setError({ field: 'newPassword', error: 'passwordIsInvalid' })
      return false
    }

    if (newPassword !== confirmNewPassword) {
      setError({ field: 'confirmNewPassword', error: 'passwordsNoMatchInvalid' })
      return false
    }

    setError({ field: '', error: '' })
    return true
  }

  const submitForm = async () => {
    if (!isFormValid()) {
      return
    }
    setIsFormSubmitted(true)

    try {
      const response = await requestChangePasswordForAuthorizedUser({ currentPassword, newPassword })

      if (response.error === 'alreadyUsedOrExpired') {
        history(FORGOT_PASSWORD_PATH)
      }
      if (response.error) {
        setError(response)
        setIsFormSubmitted(false)
      } else {
        setIsFormSubmitted(false)
        toggleModal(false)
        showSuccessToast(<FormattedMessage id='passwordChangeSuccessful' />)

      }
    } catch (e) {
      showErrorToast(<FormattedMessage id='somethingWentWrong' />)
    }
  }

  return (<>
    <PasswordInput
      field="currentPassword"
      value={currentPassword}
      label="password"
      onChange={handleOldPasswordChange}
      placeholder="enterCurrentPassword"
      error={error}
      dataTest='form-field'
    />
    <PasswordInput
      field="newPassword"
      value={newPassword}
      label="newPassword"
      onChange={handleNewPasswordChange}
      placeholder="enterNewPassword"
      error={error}
      dataTest='form-field'
    />
    <PasswordInput
      field="confirmNewPassword"
      value={confirmNewPassword}
      label="confirmNewPassword"
      onChange={handleConfirmNewPasswordChange}
      placeholder="confirmNewPassword"
      error={error}
      dataTest='form-field'
      margin='0'
    />
    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
      <div style={{ width: '95px' }}>
        <Button type='secondary' dataTest='cancel-button' onClick={() => {
          return toggleModal(false)
        }}>
          <FormattedMessage id='cancel' />
        </Button>
      </div>
      <div style={{ marginLeft: '16px' }}>
        <Button dataTest='submit' type='primary' onClick={submitForm} isPending={isFormSubmitted}>
          <FormattedMessage id='changePassword' />
        </Button>
      </div>
    </div>
  </>
  )
}

export default ChangePasswordModalForm
